// extracted by mini-css-extract-plugin
export default {"theme__card":"ThemeCard_theme__card__UmPTI","default":"ThemeCard_default__bslo8","dark":"ThemeCard_dark__rTDK8","dark_g":"ThemeCard_dark_g__Sgj4j"};